// extracted by mini-css-extract-plugin
export default {"confirmDelete":"itMLOYvbqOsh0BweIG8c","warning":"bsL83jem9PAyCzLR4a58","actions":"P7oVoQXgeAVOHJruN8UB"};